// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"3f18ef50","498":"c1aaceca","513":"5e40a84d","787":"a28727a2"}[chunkId] + ".chunk.js";
};